import {
  Amount,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
  TableFooter,
  TableFooterRow,
  TableFooterCell,
  Box,
} from '@razorpay/blade/components';
import React from 'react';
import { CtcBreakdownDataForEmployeeOnboarding } from '../../types';
import { getCalculations } from 'components/SalaryStructures/utils';

import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import { toIndianCurrencyString } from 'utils/Numbers';

interface CtcBreakdownTableProps {
  data: {
    data:
      | CtcBreakdownDataForEmployeeOnboarding['fixed']['data']
      | CtcBreakdownDataForEmployeeOnboarding['variable']['data']
      | CtcBreakdownDataForEmployeeOnboarding['otherCtc']['data'];
    totalMonthlyAmount?: number;
    totalYearlyAmount: number;
  };
  columnTitles: string[];
  showCalculations?: boolean;
  showTotal?: boolean;
}

export const CTCBreakdownTable = ({
  columnTitles,
  data,
  showCalculations = true,
  showTotal = false,
}: CtcBreakdownTableProps) => {
  const componentData = data.data;
  return (
    <Box borderRadius={'large'} overflow={'hidden'} marginTop={'spacing.3'}>
      <Table
        backgroundColor="transparent"
        showBorderedCells={false}
        display={'grid'}
        gridTemplateColumns={showCalculations ? '2fr 1fr 1fr' : '1fr 1fr'}
        data={{
          nodes: componentData,
        }}>
        {(tableData) => (
          <>
            <TableHeader>
              <TableHeaderRow>
                {columnTitles.map((col, id) => (
                  <TableHeaderCell
                    key={col}
                    textAlign={id === columnTitles.length - 1 ? 'right' : 'left'}>
                    {col}
                  </TableHeaderCell>
                ))}
              </TableHeaderRow>
            </TableHeader>
            <TableBody>
              {tableData.map((row) => (
                <TableRow key={row.id} item={row}>
                  <TableCell>{row.displayBehaviourV1?.displayName ?? row.name}</TableCell>

                  {showCalculations && (
                    <TableCell>
                      <Text>{getCalculations(row as unknown as SalaryStructureComponent)}</Text>
                    </TableCell>
                  )}

                  <TableCell textAlign="right">
                    {row.amount < 0 ? (
                      <Text>{toIndianCurrencyString(row.amount)}</Text>
                    ) : (
                      <Amount value={row.amount} suffix={'none'} />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            {showTotal && (
              <TableFooter>
                <TableFooterRow>
                  <TableFooterCell>Total Gross</TableFooterCell>

                  {showCalculations && <TableFooterCell>{''}</TableFooterCell>}

                  <TableFooterCell textAlign="right">
                    {data.totalYearlyAmount < 0 ? (
                      <Text weight="semibold">
                        {toIndianCurrencyString(data.totalYearlyAmount)}
                      </Text>
                    ) : (
                      <Amount value={data.totalYearlyAmount} suffix={'none'} />
                    )}
                  </TableFooterCell>
                </TableFooterRow>
              </TableFooter>
            )}
          </>
        )}
      </Table>
    </Box>
  );
};
